import React from "react";
import * as Cookie from "js-cookie";
import { useHistory } from "react-router-dom";
import { Constants } from "../../constants/appConstants";
import "./Footer.css";

const Footer: React.FC = () => {
  const history = useHistory();
  const copyRightYear = new Date().getFullYear();

  const logout = () => {
    Cookie.remove("userId");
    history.push("/login");
  };

  return (
    <div id="footer">
      <div className="footer-section">
        <div className="row">
          <div className="footer-section-contrainer col-lg-4 col-md-4 col-sm-4 col-4">
          <div className="footer-head">{Constants.MYACCOUNTS_SECTION}</div>
          <div className="footer-content">
            <a className="footer-logout" onClick={logout}>{Constants.LOGOUT}</a>
          </div>
          <div className="footer-content">
            <a className="reg-certificate" target="_blank" rel="noopener noreferrer"
               href={Constants.REGISTER_CERTIFICATE_URL}>
              {Constants.REGISTER_CERTIFICATE}
            </a>
          </div>
        </div>
        <div className="footer-section-contrainer col-lg-4 col-md-4 col-sm-4 col-4">
          <div className="footer-head">{Constants.CONTACTS_SECTION}</div>
          <div className="contact-info footer-content">{Constants.CONTACTS_NUMBER}</div>
          <div className="footer-content">
            <a className="help-link" href="assets/pdf/Centralized CSOS PLaceholder.pdf">
              {Constants.HELP}
            </a>
          </div>
        </div>
        <div className="footer-section-contrainer col-lg-4 col-md-4 col-sm-4 col-4">
          <div className="footer-head legal">{Constants.CARDINAL_HEALTH_SECTION}</div>
          <div className="footer-content">
            <a target="_blank" rel="noopener noreferrer" className="privacy-policy"
               href={Constants.PRIVACY_POLICY_URL}>
              {Constants.PRIVACY_POLICY}
            </a>
          </div>
          <div className="footer-content">
            <a target="_blank" rel="noopener noreferrer" className="terms-service"
               href={Constants.TERMS_OF_SERVICE_URL}>
              {Constants.TERMS_OF_SERVICE}
            </a>
          </div>
          <div className="footer-content">
            <a target="_blank" rel="noopener noreferrer" className="cardinal-health-link"
               href={Constants.CARDINAL_HEALTH_URL}>
              {Constants.CARDINAL_HEALTH}
            </a>
          </div>
          </div>
        </div>
      </div>
      <span className="copyright">
        &copy; {copyRightYear} {Constants.COPYRIGHT_DATA}
      </span>
    </div>
  );
};

export default Footer;
